/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20.1277 11.1002C17.3649 7.3284 12.3105 5.819 7.855 7.7442 2.6455 9.995.2274 16.089 2.454 21.3552c.1765.4172-.015.9-.4278 1.0784-.4128.1783-.8904-.0154-1.0668-.4326-2.5795-6.1008.2217-13.1604 6.2568-15.768 4.5292-1.957 9.5926-.8503 12.9278 2.4026a11.8996 11.8996 0 0 1 1.8109 2.2586l-.9164-6.9482-.0092-.148c.0106-.3894.2952-.7275.6896-.7885.4437-.0687.8584.2393.9264.6878L24 13.7187l-9.9151 1.368-.1464.0093c-.3852-.0109-.7195-.2986-.7798-.6973l-.0091-.148c.0107-.3894.2953-.7274.6897-.7883l7.1504-.9649a10.3647 10.3647 0 0 0-.862-1.3973Zm1.8678.114.1453-.0518.055.4066a12.2357 12.2357 0 0 0-.2003-.3548Z"
    clipRule="evenodd"
  />,
  'Redo'
);
